import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';
import { GridCol } from 'dibs-elements/exports/Grid';
import { trackShopByLocationClick } from '../helpers/shopByTracking';
import { slugify } from '../../utils/slugify';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import HpRespModuleItemTile from '../HpRespModuleItemTile/HpRespModuleItemTile';

import styles from './HpRespLocationsModuleItemList.scss';

import { HpRespLocationsModuleItemList_componentModule } from './__generated__/HpRespLocationsModuleItemList_componentModule.graphql';

type Props = {
    componentModule: HpRespLocationsModuleItemList_componentModule;
    useLazyLoadImages: boolean;
};

export const HpRespLocationsModuleItemList: FC<Props> = ({
    componentModule,
    useLazyLoadImages,
}) => {
    const { title, description, imageUrl, imageHeight, imageWidth, items } =
        componentModule?.location || {};
    return (
        <GridCol tabletLandscape={3}>
            <div className={styles.container}>
                <HpRespModuleItemTile
                    linkData={null}
                    dataTn="dealer-locations-tile"
                    title={title}
                    description={description}
                    imageUrl={imageUrl}
                    imgSrcSetWidths={[220, 360, 500, 760]}
                    imgSizes="(max-width:768px) 95vw, (max-width:1024px) 220px, 360px"
                    imageHeight={imageHeight}
                    imageWidth={imageWidth}
                    imageClass={styles.tileImage}
                    imageOverlayClass={styles.tileImageOverlay}
                    textClass={styles.tileText}
                    useLazyLoadImages={useLazyLoadImages}
                    imgOverlayContent={
                        <ul className={styles.locationsList}>
                            {(items || []).filter(filterNulls).map((item, index) => (
                                <li key={item.cmsId || index}>
                                    <SeoLink
                                        dataTn={`dealer-location-link-${slugify(item.title)}`}
                                        linkData={item.linkData}
                                        className={styles.locationLink}
                                        onClick={() => trackShopByLocationClick(item, index)}
                                    >
                                        {item.title}
                                    </SeoLink>
                                </li>
                            ))}
                        </ul>
                    }
                />
            </div>
        </GridCol>
    );
};

export default createFragmentContainer(HpRespLocationsModuleItemList, {
    componentModule: graphql`
        fragment HpRespLocationsModuleItemList_componentModule on LocationsModule {
            location {
                title
                description
                imageUrl
                imageHeight
                imageWidth
                items {
                    cmsId
                    title
                    linkData {
                        ...SeoLink_linkData
                    }
                }
            }
        }
    `,
});
